import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App.tsx'
import { startTheme } from './theme.ts'
import './design/tokens.css'
import './styles.css'

startTheme()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // An Icefield administrator's every load of a company is logged as a support view, so
      // nothing refetches on its own. Changes update the cache from ICE's answer instead.
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 30_000,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
